import React, { Component } from 'react'

class Features extends Component {
  render() {
    return (
      <section id="features" className="features">
        <div className="container">
          <h2 className="section-title">
            20{`${this.props.grad_year}`}年卒学生対象
            <br />
            各回25名参加
          </h2>
          <h3 className="sub-title">【イベント特徴】</h3>
          <div className="section-body">
            <div className="row">
              <div className="col m10 offset-m1">
                <div className="feature col s12 m4">
                  <div className="feature-inner">
                    <h4 className="feature__num">特徴１</h4>
                    <h3 className="feature__catch">
                      企業の特徴や社風が
                      <br/>
                      詳しくわかる
                    </h3>
                    <img className="feature__image" src={`${process.env.PUBLIC_URL}/assets/images/features/3.jpg`} alt="特別選考のご案内が届く" />
                    <p className="feature__detail">
                      企業の人事担当が自社の特徴や職種の詳細な内容を説明。人柄や社風など雰囲気も掴めるので、会社への理解が深まります。
                    </p>
                  </div>
                </div>
                <div className="feature col s12 m4">
                  <div className="feature-inner">
                    <h4 className="feature__num">特徴２</h4>
                    <h3 className="feature__catch">
                      1日で5社に
                      <br/>
                      自己アピールできる
                    </h3>
                    <img className="feature__image" src={`${process.env.PUBLIC_URL}/assets/images/features/1.jpg`} alt="事前準備は必要ありません" />
                    <p className="feature__detail">
                      1日で5社の企業に対して、自己アピールをする事ができ効率的。後日、特別選考ルートで本選考に進める事もあります。
                      <br/>
                      ※企業数は前後する場合があります
                    </p>
                  </div>
                </div>
                <div className="feature col s12 m4">
                  <div className="feature-inner">
                    <h4 className="feature__num">特徴３</h4>
                    <h3 className="feature__catch">
                      面接力を上げる
                      <br/>
                      3つのコツがわかる
                    </h3>
                    <img className="feature__image" src={`${process.env.PUBLIC_URL}/assets/images/features/2.png`} alt="参加企業からの評価が確認できる" />
                    <p className="feature__detail">
                      面接で重要な3つのスキルをデータで可視化。希望者には個別の改善策をお伝えするので、面接に自信が持てます。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>    
      </section>

    )
  }
}

export default Features